<script>
import axios from "axios";

export default {
  name: "ForgotPasswordView",
  data() {
    return {
      email: "",
      loading: false,
      submitted: false,
      message: "",
      errorMessage: "",
    };
  },
  methods: {
    async requestReset() {
      this.loading = true;
      this.errorMessage = "";
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/auth/forgot-password`,
          { email: this.email.trim() },
          { headers: { "Content-Type": "application/json" } }
        );
        this.message = response.data.message;
        this.submitted = true;
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message ||
          "Password reset is temporarily unavailable. Please try again.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid bg-body-tertiary">
    <div class="d-flex align-items-center py-4 min-vh-100">
      <main class="recovery-card w-100 m-auto">
        <img
          src="@/assets/logo.png"
          class="mb-4"
          alt="First City Polytechnic"
          width="96.26"
          height="70"
        />

        <template v-if="!submitted">
          <h1 class="h3 mb-3 fw-bold">Forgot your password?</h1>
          <p class="text-body-secondary mb-4">
            Enter the email registered to your applicant or student account.
          </p>

          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ errorMessage }}
          </div>

          <form @submit.prevent="requestReset">
            <div class="form-floating mb-3">
              <input
                id="resetEmail"
                v-model.trim="email"
                type="email"
                class="form-control"
                placeholder="name@example.com"
                autocomplete="email"
                required
                :disabled="loading"
              />
              <label for="resetEmail">Email address</label>
            </div>

            <div class="d-grid gap-2">
              <button class="btn btn-success" type="submit" :disabled="loading">
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm me-2"
                  aria-hidden="true"
                ></span>
                {{ loading ? "Sending..." : "Send reset link" }}
              </button>
              <RouterLink
                class="btn btn-link text-decoration-none"
                :to="{ name: 'login' }"
              >
                <i class="bi bi-arrow-left me-1"></i> Back to sign in
              </RouterLink>
            </div>
          </form>
        </template>

        <template v-else>
          <div class="recovery-icon mx-auto mb-3">
            <i class="bi bi-envelope-check"></i>
          </div>
          <h1 class="h3 mb-3 fw-bold">Check your email</h1>
          <p class="text-body-secondary">{{ message }}</p>
          <p class="small text-body-secondary mb-4">
            A link, when issued, remains valid for 30 minutes. Check your spam
            folder if it does not appear in your inbox.
          </p>
          <div class="d-grid gap-2">
            <button
              class="btn btn-outline-secondary"
              type="button"
              @click="submitted = false"
            >
              Use another email
            </button>
            <RouterLink class="btn btn-success" :to="{ name: 'login' }">
              Return to sign in
            </RouterLink>
          </div>
        </template>

        <hr class="mt-5" />
        <p class="mt-3 mb-0 text-body-secondary">
          © 2022–{{ new Date().getFullYear() }}
        </p>
      </main>
    </div>
  </div>
</template>

<style scoped>
.recovery-card {
  max-width: 530px;
  padding: 1rem;
}

.recovery-icon {
  align-items: center;
  background: #e9f7ef;
  border-radius: 50%;
  color: #198754;
  display: flex;
  font-size: 2rem;
  height: 72px;
  justify-content: center;
  width: 72px;
}
</style>
